module.exports = __webpack_public_path__ + "img/cat-head.34991037.png";